// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_oz-0";
export var discountCodeInput = "_oz-1";